import { render, staticRenderFns } from "./AddAuthorizedPerson.vue?vue&type=template&id=533c4e06&scoped=true"
import script from "./AddAuthorizedPerson.vue?vue&type=script&lang=ts"
export * from "./AddAuthorizedPerson.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c4e06",
  null
  
)

export default component.exports